<template>
	<v-card class="card-curvey">
	<v-layout row wrap class="align-center">
        <v-flex xs4>
          <h3>Attach Feature</h3>
        </v-flex>
    </v-layout>
      <div
        class="mt-3">
        <v-autocomplete
                v-model="input.entities"
                :items="entities"
                item-text="modelName"
                item-value="modelName"
                chips
                return-object
                outline
                solo
                multiple
        >
            <template v-slot:selection="data">
                <v-chip
                        :selected="data.selected"
                        close
                        @input="input.entities.splice(data.index, 1)"
                >
                    <strong>{{ data.item.modelName }}</strong>&nbsp;
                </v-chip>
            </template>
        </v-autocomplete>
      </div>
      <v-layout>
      	<v-spacer />
        <v-btn
        	style="alignment: right"
            color="primary"
            @click="submit">
          	Save
        </v-btn>
      </v-layout>
    </v-card>
</template>

<script>
export default {

  name: 'IntentFeatures',

  data () {
    return {
    	input: {
    		entities: []
    	}
    }
  },
  mounted() {
  	this.getEntities()
  },
  computed: {
  	selectedApp() {
  		return this.$store.state.nlp.selectedApp
  	},
  	selectedIntent() {
  		return this.$route.params.intent
  	},
  	initialFeatures() {
  		return this.$store.state.nlp.selectedIntent && this.$store.state.nlp.selectedIntent.features ?  this.$store.state.nlp.selectedIntent.features : []
  	},
    entities() {
      return this.$store.state.nlp.entities
      .filter(e => e.type === 'list')
      .map(e => ({
        modelName: e.name,
        id: e.id
      }))
    }
  },
  watch: {
  	initialFeatures: {
  		deep: true,
  		immediate: true,
  		handler(val) {
  			if(val) {
  				this.input.entities = this.$_.cloneDeep(val)
  			}
  		}
  	}
  },
  methods: {

  	deleteFeature() {
  		return true
  	},
  	getRemoves() {
  		const current = this.input.entities.map(i => i.modelName)
  		const initial = this.initialFeatures.map(i => i.modelName)
  		return this.$_.difference(initial, current)
  	},
  	getAdditions() {
  		const current = this.input.entities.map(i => i.modelName)
  		const initial = this.initialFeatures.map(i => i.modelName)
  		return this.$_.difference(current, initial)
  	},
  	getEntities() {
  		this.$store.dispatch('setLoader',true)
  		this.$store.dispatch('nlp/entities/get').then(()=>{
  			this.$store.dispatch('setLoader',false)
  		}).catch(()=>{
  			this.$store.dispatch('setLoader',false)
  			this.$store.dispatch('setErrorMessage', true)
  		})
  	},
  	async addFeature(id) {
  		try {
        const filtered = this.entities.filter(e => e.modelName === id)
        if(!filtered || !filtered.length) return;

  			await this.$http_nlp.put(`/apps/${this.selectedApp.id}/intents/${this.selectedIntent}/features/${filtered[0].id}/add`)
  			return true
  		} catch(err) {
        throw err
  			return false
  		}
  	},
  	async removeFeature(id) {
  		try {
        console.log('rem', id)
        const filtered = this.entities.filter(e => e.modelName === id)
        if(!filtered || !filtered.length) return;
  			await this.$http_nlp.put(`/apps/${this.selectedApp.id}/intents/${this.selectedIntent}/features/${filtered[0].id}/remove`)
  			return true
  		} catch(err) {
        throw err
  			return false
  		}
  	},
    async submit() {
      try {
        this.$store.dispatch('setLoader',true)
        const removals = this.getRemoves()
        const additions = this.getAdditions()
        // remove
        let i
        for(i = 0; i < removals.length; i +=1) {
          await this.removeFeature(removals[i])
        }
        // add
        for(i = 0; i < additions.length; i +=1) {
          await this.addFeature(additions[i])
        }
        this.$store.dispatch('setLoader',false)
        this.getIntent()

      } catch(err) {
        this.$store.dispatch('setLoader',false)
        this.$store.dispatch('setErrorMessage', true)
      }
    },
    async getIntent() {
      this.$store.dispatch('setLoader',true)
      this.$store.dispatch(
        'nlp/intents/get/single',
        this.$route.params.intent
      ).then(()=>{
        this.$store.dispatch('setLoader',false)
      }).catch(()=>{
         this.$store.dispatch('setLoader',false)
         this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
